import React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { useCart } from "../lib/store";
import { brl, productImage, uploadUrl } from "../lib/api";
import { Minus, Plus, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";

export default function CartDrawer() {
  const { items, open, setOpen, remove, setQty, total } = useCart();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="bg-[#FAFAF7] w-full sm:max-w-md p-0 flex flex-col">
        <SheetHeader className="p-6 border-b border-[#0D1B2A]/8">
          <SheetTitle className="font-display text-2xl text-[#0D1B2A]">Seu carrinho</SheetTitle>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto p-6 space-y-4" data-testid="cart-items">
          {items.length === 0 && (
            <div className="text-center py-12 text-[#6B7280]">
              <div className="font-script text-[#D4AF37] text-3xl mb-2">vazio por ora</div>
              <p className="text-sm">Adicione lembranças que ficam para sempre.</p>
            </div>
          )}

          {items.map((it, idx) => (
            <div key={idx} className="flex gap-4 bg-white rounded-2xl p-3 border border-[#0D1B2A]/5">
              <div className="w-20 h-20 rounded-xl overflow-hidden bg-[#F7F2E7] shrink-0">
                {it.photo_id ? (
                  <img src={uploadUrl(it.photo_id)} alt="foto" className="w-full h-full object-cover" />
                ) : (
                  <img src={productImage(it)} alt={it.name} className="w-full h-full object-cover" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-display text-[15px] text-[#0D1B2A] leading-tight">{it.name}</div>
                <div className="text-[12px] text-[#6B7280] mt-1">{brl(it.price)} un.</div>
                <div className="flex items-center justify-between mt-2">
                  <div className="flex items-center gap-2 border border-[#0D1B2A]/10 rounded-full px-1">
                    <button className="w-7 h-7 flex items-center justify-center" onClick={() => setQty(idx, it.quantity - 1)} data-testid={`cart-qty-dec-${idx}`}>
                      <Minus size={12} />
                    </button>
                    <span className="text-[13px] w-6 text-center" data-testid={`cart-qty-${idx}`}>{it.quantity}</span>
                    <button className="w-7 h-7 flex items-center justify-center" onClick={() => setQty(idx, it.quantity + 1)} data-testid={`cart-qty-inc-${idx}`}>
                      <Plus size={12} />
                    </button>
                  </div>
                  <button onClick={() => remove(idx)} className="text-[#6B7280] hover:text-[#E66E6E]" data-testid={`cart-remove-${idx}`}>
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="p-6 border-t border-[#0D1B2A]/8 bg-white space-y-4">
          <div className="flex items-center justify-between">
            <span className="text-sm text-[#6B7280]">Subtotal</span>
            <span data-testid="cart-total" className="font-display text-2xl text-[#0D1B2A]">{brl(total)}</span>
          </div>
          <Link
            to="/checkout"
            onClick={() => setOpen(false)}
            data-testid="cart-checkout-link"
            className={`btn-gold w-full text-center block ${items.length === 0 ? "opacity-50 pointer-events-none" : ""}`}
          >
            Finalizar compra
          </Link>
          <p className="text-[11px] text-center text-[#6B7280]">Pagamento seguro via Mercado Pago · Retirada em Curitiba/PR ou envio</p>
        </div>
      </SheetContent>
    </Sheet>
  );
}
